module.exports = __webpack_public_path__ + "img/ax-desktop-default.2cf5d681.png";